<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>

        <form [formGroup]="editAddTinForm">
          <div class="upperContainer">
            <mat-form-field appearance="outline" class="formField">
              <mat-label for="name">Name</mat-label>
              <input cdkFocusInitial #name matTooltip={{name.value}} matInput placeholder="Name" formControlName="name" />
              @if (editAddTinForm.get('name')?.invalid && (editAddTinForm.get('name')?.dirty || editAddTinForm.get('name')?.touched)) {
                <mat-error>
                  @if (editAddTinForm.get('name')?.errors?.['required']) {
                    Name is required.
                  }
                  @if (editAddTinForm.get('name')?.errors?.['maxlength']) {
                    Name must be no more than 128 characters long.
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="formField">
              <mat-label for="tin">TIN</mat-label>
              <input #tin matTooltip={{tin.value}} matInput placeholder="TIN" formControlName="tin" />
              @if (editAddTinForm.get('tin')?.invalid && (editAddTinForm.get('tin')?.dirty || editAddTinForm.get('tin')?.touched)) {
                <mat-error>
                  @if (editAddTinForm.get('tin')?.errors?.['required']) {
                    TIN is required.
                  }
                  @if (editAddTinForm.get('tin')?.errors?.['maxlength']) {
                    TIN must be no more than 11 characters long.
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="dateContainer">
            <mat-form-field appearance="outline" class="formField">
              <mat-label>Effective Date</mat-label>
              <input matInput [matDatepicker]="startPicker" formControlName="effectiveDate" placeholder="MM/DD/YYYY" [max]="editAddTinForm.get('expirationDate')?.value" [required]="!!editAddTinForm.get('expirationDate')?.value" />
              <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
              @if (editAddTinForm.get('effectiveDate')?.errors?.['effectiveDateRequired'] && (editAddTinForm.get('effectiveDate')?.touched || editAddTinForm.get('expirationDate')?.value)) {
                <mat-error>Effective Date is required when an Expiration Date is set.</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="formField">
              <mat-label>Expiration Date</mat-label>
              <input matInput [matDatepicker]="endPicker" formControlName="expirationDate" placeholder="MM/DD/YYYY" [min]="editAddTinForm.get('effectiveDate')?.value" />
              <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
              @if (editAddTinForm.get('expirationDate')?.errors?.['endBeforeStart'] && editAddTinForm.get('expirationDate')?.touched) {
                <mat-error>Expiration Date must be on or after Effective Date.</mat-error>
              }
            </mat-form-field>
          </div>
      </form>

</mat-dialog-content>
<mat-dialog-actions>
  <div class="actionContainer">
    <button
    mat-button
    (click)="submitTin()"
    id="saveButton"
    [disabled]="!editAddTinForm.valid || this.hasSaveButtonBeenPressed || (isSaveDisabled$ | async)"
  >
    Save
  </button>
  <button mat-button mat-dialog-close>Close</button>
</div>
</mat-dialog-actions>
